module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "two-col-content row"
  }, [_c('div', {
    staticClass: "settings-holder"
  }, [_c('h1', {
    staticClass: "headerone__default__large"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "settings-holder-inner"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.profileId),
      callback: function($$v) {
        _vm.profileId = $$v
      },
      expression: "profileId"
    }
  }, _vm._l((_vm.statsProfiles), function(profile) {
    return _c('el-radio-button', {
      key: profile.id,
      attrs: {
        "value": profile.id,
        "label": profile.id
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(profile.name))]), _vm._v(" "), _c('span', {
      staticClass: "columns"
    }, [_c('p', [_vm._v(_vm._s(profile.columns))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "profile-select-holder"
  }, [_c('el-button', {
    staticClass: "btn__default",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "campaign-loader"
  }, [_c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('button', {
    staticClass: "close-settings",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98ec9b3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setting.vue
// module id = +8Da
// module chunks = 1